/* eslint-disable global-require */
// import conf from 'conf'
// import i18n from 'i18n'

import appTypeConfigFunc from 'apptype-config'

export default async function getMenuData() {
  const appTypeConfig = appTypeConfigFunc()
  const { adminMenuList, menuList } = appTypeConfig.menu()

  return { adminMenuList, menuList }
}
